import { BaseNomenclature } from "./baseNomenclature.model";

export class Coefficient extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="coefficient";
    }
}